export default __webpack_public_path__ + "static/media/car.186c2658.svg";